interface CheckIsQuestionTypeEmptyParams {
  multipleChoice: boolean;
  trueFalse: boolean;
  shortAnswers: boolean;
}
export function checkIsQuestionTypeEmpty({
  multipleChoice,
  trueFalse,
  shortAnswers,
}: CheckIsQuestionTypeEmptyParams) {
  return !multipleChoice && !trueFalse && !shortAnswers;
}
